import React, { useState, useEffect, useRef } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import TextArea from "components/TextArea";
import { useMutation } from "@apollo/client";
import { UPDATE_CHARGE } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import colors from "constants/colors";
import { debouncedErrorMessage } from "utils/messageUtil";

const ModalEditCharge = ({
  hidden,
  buttonIcon,
  iconStyle,
  charge,
  setBill,
}) => {

  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const [inputError, setInputError] = useState(false);
  const [chargeAmount, setChargeAmount] = useState(charge.amount);
  
  const [chargeDetails, setChargeDetails] = useState("");
  const [textAreaError, setTextAreaError] = useState(false);

  const [editCharge, { loading }] = useMutation(UPDATE_CHARGE, {
    onCompleted: (data) => {
      setBill(data.updateCharge);
      setIsOpen(false);
    },
    onError: (error) => {
      debouncedErrorMessage(error.message);
    },
  });

  const handleEditCharge = () => {
    if (loading) return;
    let error = false;

    if (chargeAmount === "") {
      setInputError(true);
      error = true;
    }

    if (chargeDetails === "") {
      setTextAreaError(true);
      error = true;
    }

    if (error) return;

    editCharge({
      variables: {
        input: {
          id: charge.chargeId,
          notes: chargeDetails,
          amount: Number(chargeAmount),
        },
      },
    })
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonIcon={buttonIcon}
        iconStyle={iconStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Edit Charge</Head>
        <Container>
          <div className="inputRow">
            <div className="info">
              <div className="label">CHARGE TYPE</div>
              <div className="value">{charge.category}</div>
            </div>
            <div className="info">
              <div className="label">ROOM NUMBER</div>
              <div className="value">{"Room" + charge.roomNumber}</div>
            </div>
          </div>
          <div className="inputRow">
            <Input
              inputFieldRef={inputRef}
              title="CHARGE AMOUNT"
              required
              error={inputError}
              errorMessage="Please enter a valid amount"
              value={chargeAmount}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(inputValue)) {
                  setChargeAmount(inputValue);
                  setInputError(false);
                }
              }}
              additionalstyle={`
                width: calc(50% - 8px);

                input {
                  padding-left: 22px;
                }

                ::before {
                  content: '$';
                  font-size: 16px;
                  font-weight: 600;
                  position: absolute;
                  color: ${colors.white};
                  left: 12px;
                  top: 32px;
                }

                .warning {
                  white-space: nowrap;
                }
              `}
            />
          </div>
          <TextArea
            title="CHARGE DETAILS"
            required
            rows={4}
            error={textAreaError}
            description="Note this appears publicly to the customer on their bill."
            value={chargeDetails}
            onChange={(e) => {
              setChargeDetails(e.target.value);
              setTextAreaError(false);
            }}
            additionalstyle={`
              flex-basis: 100%;
            `}
          />
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 84px;
            `}
            onClick={handleEditCharge}
            data-loading={loading}
          >
            {loading ? null : "Submit"}
          </Button>
        </Footer>
      </MainModal>
    </>
  );
};

export default ModalEditCharge;
